import { stateMachine } from "appworks/state-machine/state-machine";
import { SlingoFreeSpinsRemainingDecision } from "slingo/states/decisions/slingo-free-spins-remaining-decision";
import { SlingoHasJokerDecision } from "slingo/states/decisions/slingo-has-joker-decision";
import { SlingoRecoveryIsBeforeFirstSpinDecision } from "slingo/states/decisions/slingo-recovery-is-before-first-spin-decision";
import { SlingoSpinPurchasedDecision } from "slingo/states/decisions/slingo-spin-purchased-decision";
import { SlingoStakeToSpinWonDecision } from "slingo/states/decisions/slingo-stake-to-spin-won-decision";
import { SlingoStandardSpinsRemainingDecision } from "slingo/states/decisions/slingo-standard-spins-remaining-decision";
import { SlingoTicketCompletedDecision } from "slingo/states/decisions/slingo-ticket-completed-decision";
import { IsBonusTriggeredDecision } from "slotworks/state-machine/standard/decisions/is-bonus-triggered-decision";
import { IsRecoveryDecision } from "slotworks/state-machine/standard/decisions/is-recovery-decision";
import { FowlInSlotBonusDecision } from "state-machine/decisions/fowl-in-slot-bonus-decision";
import { FowlSlotSpinsRemainingDecision } from "state-machine/decisions/fowl-slot-spins-remaining-decision";
import { FowlEnterFlingBonusState } from "state-machine/states/bonus/fling/fowl-enter-fling-bonus-state";
import { FowlExitFlingBonusState } from "state-machine/states/bonus/fling/fowl-exit-fling-bonus-state";
import { FowlFlingBonusState } from "state-machine/states/bonus/fling/fowl-fling-bonus-state";
import { FowlExitPickBonusState } from "state-machine/states/bonus/pick/fowl-exit-pick-bonus-state";
import { FowlPickBonusState } from "state-machine/states/bonus/pick/fowl-pick-bonus-state";
import { FowlExitSlotBonusState } from "state-machine/states/bonus/slot/fowl-exit-slot-bonus-state";
import { FowlSlotBonusIdleState } from "state-machine/states/bonus/slot/fowl-slot-bonus-idle-state";
import { FowlSlotLoopWinsState } from "state-machine/states/bonus/slot/fowl-slot-loop-wins-state";
import { FowlSlotShowWinsState } from "state-machine/states/bonus/slot/fowl-slot-show-wins-state";
import { FowlSlotSpinState } from "state-machine/states/bonus/slot/fowl-slot-spin-state";
import { FowlBigWinState } from "state-machine/states/fowl-big-win-state";
import { FowlFullHouseState } from "state-machine/states/fowl-full-house-state";
import { SocialEnterBaseGameState } from "states/social-enter-base-game-state";
import { SocialEnterPickBonusState } from "states/social-enter-pick-bonus-state";
import { SocialEnterSlotBonusState } from "states/social-enter-slot-bonus-state";
import { SocialGameOverState } from "states/social-game-over-state";
import { SocialIdleState } from "states/social-idle-state";
import { SocialInitState } from "states/social-init-state";
import { SocialPickJokerState } from "states/social-pick-joker-state";
import { SocialPurchaseEntryState } from "states/social-purchase-entry-state";
import { SocialPurchaseSpinOrCollectState } from "states/social-purchase-spin-or-collect-state";
import { SocialRecoveryState } from "states/social-recovery-state";
import { SocialRequestSpinState } from "states/social-request-spin-state";
import { SocialSpinState } from "states/social-spin-state";

/**
 * FowlStateSetup() override
 */

/**
 * State Diagram
 * https://drive.google.com/file/d/1Yvj_j_uGzKVSkIP5CDNdie1bpvNWlZW9/view?usp=sharing
 */

export function FowlStateSetup() {
    // States
    const initState = new SocialInitState();
    const idleState = new SocialIdleState();
    const recoveryState = new SocialRecoveryState();
    const purchaseEntryState = new SocialPurchaseEntryState();
    const requestSpinState = new SocialRequestSpinState();
    const stakeToSpinRequestSpinState = new SocialRequestSpinState({ skipRequest: true });
    const spinState = new SocialSpinState();
    const pickJokerState = new SocialPickJokerState();
    const purchaseOrCollectState = new SocialPurchaseSpinOrCollectState({ hideSpinButtonWhenPurchaseButtonVisible: true });
    const gameOverState = new SocialGameOverState();
    const bigWinState = new FowlBigWinState();
    const fullHouseState = new FowlFullHouseState();

    const enterBaseGameState = new SocialEnterBaseGameState();

    const enterPickBonusState = new SocialEnterPickBonusState();
    const pickBonusState = new FowlPickBonusState();
    const exitPickBonusState = new FowlExitPickBonusState();

    const enterFlingBonusState = new FowlEnterFlingBonusState();
    const flingBonusState = new FowlFlingBonusState();
    const exitFlingBonusState = new FowlExitFlingBonusState();

    const enterSlotBonusState = new SocialEnterSlotBonusState();
    const slotIdleState = new FowlSlotBonusIdleState();
    const slotSpinState = new FowlSlotSpinState();
    const slotShowWinsState = new FowlSlotShowWinsState();
    const slotLoopWinsState = new FowlSlotLoopWinsState();
    const exitSlotBonusState = new FowlExitSlotBonusState();

    // Decisions
    const isRecoveryDecision = new IsRecoveryDecision();
    const hasJokerDecision = new SlingoHasJokerDecision();
    const standardSpinsRemainingDecision = new SlingoStandardSpinsRemainingDecision();
    const freeSpinsRemainingDecision = new SlingoFreeSpinsRemainingDecision();
    const ticketCompletedDecision = new SlingoTicketCompletedDecision();
    const spinPurchasedDecision = new SlingoSpinPurchasedDecision();
    const recoveryBeforeFirstSpinDecision = new SlingoRecoveryIsBeforeFirstSpinDecision();

    const scatterPickBonusTriggered = new IsBonusTriggeredDecision("eggpick");
    const isEggPickBonusTriggered = new IsBonusTriggeredDecision("eggpick");
    const isJackpotBonusTriggered = new IsBonusTriggeredDecision("jackpot");
    const isSlotBonusTriggered = new IsBonusTriggeredDecision("slotbonus");

    const inSlotBonusDecision = new FowlInSlotBonusDecision();
    const wasPickTriggeredFromSlotDecision = new FowlInSlotBonusDecision();
    const slotSpinsRemainingDecision = new FowlSlotSpinsRemainingDecision();
    const isGameCompleteDecision = new SlingoTicketCompletedDecision();

    const isStakeToSpinWonDecision = new SlingoStakeToSpinWonDecision();

    stateMachine.addStates([
        { state: initState, entryPoint: true, links: { complete: isRecoveryDecision } },
        { state: recoveryState, links: { complete: recoveryBeforeFirstSpinDecision } },

        { state: idleState, links: { complete: purchaseEntryState } },
        { state: purchaseEntryState, links: { complete: requestSpinState, error: idleState } },
        { state: requestSpinState, links: { complete: spinState, error: purchaseOrCollectState } },
        { state: stakeToSpinRequestSpinState, links: { complete: spinState } },
        { state: spinState, links: { complete: ticketCompletedDecision } },
        { state: pickJokerState, links: { complete: ticketCompletedDecision } },
        { state: purchaseOrCollectState, links: { complete: isStakeToSpinWonDecision } },
        { state: bigWinState, links: { complete: gameOverState } },
        { state: gameOverState, links: { complete: idleState } },
        { state: fullHouseState, links: { complete: isSlotBonusTriggered } },

        { state: enterBaseGameState, links: { complete: isGameCompleteDecision } },

        { state: enterPickBonusState, links: { complete: pickBonusState } },
        { state: pickBonusState, links: { complete: exitPickBonusState } },
        { state: exitPickBonusState, links: { complete: isJackpotBonusTriggered } },

        { state: enterFlingBonusState, links: { complete: flingBonusState } },
        { state: flingBonusState, links: { complete: exitFlingBonusState } },
        { state: exitFlingBonusState, links: { complete: wasPickTriggeredFromSlotDecision } },

        { state: enterSlotBonusState, links: { complete: slotIdleState, error: exitSlotBonusState } },
        { state: slotIdleState, links: { complete: slotSpinState } },
        { state: slotSpinState, links: { complete: slotShowWinsState } },
        { state: slotShowWinsState, links: { complete: slotLoopWinsState }, cascadeSkip: true },
        { state: slotLoopWinsState, links: { complete: isEggPickBonusTriggered } },
        { state: exitSlotBonusState, links: { complete: enterBaseGameState } },
    ]);

    stateMachine.addDecisions([
        { decision: isRecoveryDecision, links: { true: recoveryState, false: idleState } },
        { decision: recoveryBeforeFirstSpinDecision, links: { true: requestSpinState, false: spinState } },
        { decision: hasJokerDecision, links: { true: pickJokerState, false: scatterPickBonusTriggered } },
        { decision: standardSpinsRemainingDecision, links: { true: requestSpinState, false: freeSpinsRemainingDecision } },
        { decision: freeSpinsRemainingDecision, links: { true: requestSpinState, false: purchaseOrCollectState } },
        { decision: spinPurchasedDecision, links: { true: requestSpinState, false: isSlotBonusTriggered } },
        { decision: ticketCompletedDecision, links: { true: fullHouseState, false: hasJokerDecision } },

        { decision: isSlotBonusTriggered, links: { true: enterSlotBonusState, false: isEggPickBonusTriggered } },
        { decision: isEggPickBonusTriggered, links: { true: enterPickBonusState, false: inSlotBonusDecision } },
        { decision: inSlotBonusDecision, links: { true: slotSpinsRemainingDecision, false: bigWinState } },
        { decision: slotSpinsRemainingDecision, links: { true: slotSpinState, false: exitSlotBonusState } },

        { decision: scatterPickBonusTriggered, links: { true: enterPickBonusState, false: standardSpinsRemainingDecision } },
        { decision: isJackpotBonusTriggered, links: { true: enterFlingBonusState, false: wasPickTriggeredFromSlotDecision } },
        { decision: wasPickTriggeredFromSlotDecision, links: { true: enterSlotBonusState, false: enterBaseGameState } },
        { decision: isGameCompleteDecision, links: { true: bigWinState, false: standardSpinsRemainingDecision } },

        { decision: isStakeToSpinWonDecision, links: { true: stakeToSpinRequestSpinState, false: spinPurchasedDecision } },
    ]);
}
